import { Card, CardContent, Skeleton } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { formatOwnerRevenue, type OwnerSummary } from '../../model';

export interface OwnersSummaryProps {
  summary?: OwnerSummary | undefined;
  loading: boolean;
  error: boolean;
}

export function OwnersSummary(props: OwnersSummaryProps) {
  const items = [
    { label: dashboardT('owners.summary.owners'), value: props.summary?.ownersNo ?? 0 },
    { label: dashboardT('owners.summary.partners'), value: props.summary?.dpNo ?? 0 },
    { label: dashboardT('owners.summary.integrations'), value: props.summary?.dpcNo ?? 0 },
    {
      label: dashboardT('owners.summary.revenue7d'),
      value: formatOwnerRevenue(props.summary?.rev7d),
    },
  ];

  return (
    <section
      aria-label={dashboardT('owners.summary.label')}
      className="grid grid-cols-2 gap-3 xl:grid-cols-4"
    >
      {items.map((item) => (
        <Card
          key={item.label}
          className="border-border bg-card min-w-0 rounded-md shadow-[var(--shadow-xs)]"
        >
          <CardContent className="p-5 text-center">
            <p className="text-muted-foreground text-sm font-medium">{item.label}</p>
            {props.loading ? (
              <Skeleton className="mx-auto mt-2 h-8 w-20" />
            ) : (
              <p className="mt-2 text-2xl font-semibold tabular-nums">
                {props.error ? '-' : item.value}
              </p>
            )}
          </CardContent>
        </Card>
      ))}
    </section>
  );
}
